/* eslint-disable prettier/prettier */
import React from 'react'
import { Container } from '../styles/BannerLayout'
const Banner = () => (
  <Container />
)
export default Banner